<template>
  <div>
    <el-dialog
        width="40%"
        :title="couponsTitle"
        :close-on-click-modal="false"
        :visible.sync="couponsDialogFormVisible" :before-close="closeHandle">
      <el-form :model="couponsForm" :rules="rules" ref="form" :show-message="false" status-icon label-position="top">
        <el-form-item label=" Coupon name" prop="coupon_name" required>
          <el-input v-model="couponsForm.coupon_name" type="text" placeholder="Input coupon name" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="Coupon type" prop="type" required>
          <el-select v-model="couponsForm.type" placeholder="" @change="typeChange">
            <el-option
              v-for="(item, index) in couponsOption"
              :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="couponsForm.type === 1" label="Rate" prop="rate" required :rules="rules.rate">
          <el-input class="rate" placeholder="Input a rate between $0.10 ~ 99.00" v-model="couponsForm.rate">
            <span slot="prefix" class="font-normal">$</span>
          </el-input>
        </el-form-item>
        <el-form-item v-if="couponsForm.type === 2" label="Percentage" prop="rate" required :rules="rules.rate">
<!--          <div class="per_box">-->
          <el-input class="ts" placeholder="Input a an integer between 1 and 99 for the percentage off" v-model="couponsForm.rate">
            <span slot="suffix" class="text-black font-normal">% off</span>
          </el-input>
<!--          </div>-->
        </el-form-item>
        <div class="flex justify-between items-end">
          <el-form-item label="Spend threshold" prop="spend_threshold" required class="flex-1 mr-[18px]">
            <el-input :disabled="!!limitCheck" v-model="couponsForm.spend_threshold" placeholder="Input a spend threshold"></el-input>
          </el-form-item>
          <el-checkbox v-model="limitCheck" class="mb-[6px]" @change="limitChange">No limit</el-checkbox>
        </div>
        <div class="flex justify-between items-end date_time">
          <el-form-item label="Deadline" prop="date" required>
            <el-date-picker
                class="w-[233px]"
                v-model="couponsForm.date"
                type="date"
                format="MM dd, yyyy"
                value-format="yyyy-MM-dd"
                placeholder="Select a date">

            </el-date-picker>
          </el-form-item>
          <el-form-item :rules="rules.time" prop="time">
            <el-time-picker
                format="hh:mm A"
                v-model="couponsForm.time"
                value-format="hh:mm A"
                placeholder="Select a time">
            </el-time-picker>
          </el-form-item>
<!--          <el-form-item label=" " prop="time" required>-->

<!--          </el-form-item>-->
        </div>
        <el-form-item label="Valid Size" prop="valid_sizes" required :rules="rules.valid_sizes" :class="{valid: valid}">
          <el-checkbox-group v-model="couponsForm.valid_sizes">
            <el-checkbox label="1">Small</el-checkbox>
            <el-checkbox label="2">Medium</el-checkbox>
            <el-checkbox label="3">Large</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelHandler" plain class="w-[80px] changeFocus p-0 border-black text-black">Cancel</el-button>
        <el-button type="success" @click="submitHandler" class="w-[80px] p-0">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addCoupon, editCoupon} from "@/api/coupon";

export default {
  name: "create-and-edit",
  props: {
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const validSize = (rule, value, callback) => {
      if (!value.length) {
        this.valid = true
        return callback(new Error(''))
      }
      this.valid = false
      callback()
    }
    const validRate = (rule, value, callback) => {
      const num1Reg = /^\d+(\.\d+)?$/
      if (this.couponsForm.type === 1) {
        if (!num1Reg.test(value) || value > 99 || value < 0.1) {
          return callback(new Error())
        }
      }
      if (this.couponsForm.type === 2){
        if (value > 99 || value < 1) {
          return callback(new Error())
        }
      }
      callback()
    }
    const validSpeed = (rule, value, callback) => {
      const Reg = /^\d+(\.\d+)?$/
      if (!Reg.test(value)) {
        return callback(new Error())
      }
      callback()
    }
    return {
      rules: {
        time: [
          { required: true, trigger: ["blur", 'change'] },
        ],
        date: [
            { required: true, trigger: ["blur", 'change'] },
        ],
        valid_sizes: [
          { validator: validSize, trigger: ["blur", 'change'] }
        ],
        rate: [
          { validator: validRate, trigger: ["blur", 'change'] },
        ],
        spend_threshold: [
          { validator: validSpeed, trigger: ["blur", 'change'] },
        ]
      },
      valid: false,
      couponsTitle: 'Create a coupon',
      couponsDialogFormVisible: false,
      couponsOption: [
        {label:'Flat rate',value: 1},
        {label:'Percentage',value: 2},
      ],
      limitCheck: false,
      couponsForm: {
        limitCheck:false,
        type: 1,
        coupon_name: '',
        rate: '',
        percentage: '',
        spend_threshold: '',
        valid_sizes: [],
        date: '',
        time: ''
      }
    }
  },
  mounted() {
  },
  methods: {
    cancelHandler() {
      // this.clearData()
      this.couponsDialogFormVisible = false;
    },
    clearData() {
      for(let key of Object.keys(this.couponsForm)) {
        if (key === 'type') {
          this.couponsForm[key] = 1
        } else if (key === 'valid_sizes') {
          this.couponsForm[key] = []
        } else {
          this.couponsForm[key] = ''
        }
      }
      this.limitCheck = false
      // this.$refs.form.resetFields()
      // this.$nextTick(() => {
      //   this.$refs.form.clearValidate()
      // })
    },
    closeHandle(done) {
      // this.clearData()
      done()
    },
    submitHandler() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const params = {
            ...this.couponsForm,
            deadline: `${this.couponsForm.date} ${this.couponsForm.time}`,
          }
          delete params.date
          delete params.time
          if (this.row.id) {
            editCoupon({ ...params, id: this.row.id }).then(res => {
              if (res.code === 200) {
                this.$message.success('edit successfully')
                this.couponsDialogFormVisible = false
                this.$emit('updateList')
                // this.clearData()
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            addCoupon(params).then(res => {
              if (res.code === 200) {
                this.couponsDialogFormVisible = false
                this.$emit('updateList')
                this.$message.success('add successfully')
                // this.clearData()
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        }else {
          this.$message({
            type:"warning",
            message:"Some information missing"
          })
        }
      })
    },
    limitChange(e) {
      if (e) {
        this.couponsForm.spend_threshold = 0
      }
    },
    typeChange() {
      this.couponsForm.rate = ''
    },
    copyData() {
      Object.keys(this.couponsForm).forEach((key) => {
        if (this.row[key]) {
          this.couponsForm[key] = this.row[key]
        }
      })
      this.couponsForm.valid_sizes = this.couponsForm.valid_sizes.split(',')
      console.log(this.row.deadline)
      const dateTime = this.row.deadline.split(' ')
      this.couponsForm.date = dateTime[0]
      console.log(dateTime,'dateTime')
      this.couponsForm.time =dateTime[1] + ' ' + dateTime[2]
      if (this.couponsForm['spend_threshold'] == '0.00'){
        this.limitCheck = true
      }else {
        this.limitCheck = false
      }
      console.log(this.couponsForm.time)
    },
    // formattedTime(data) {
    //   // 将时间字符串拆分为小时、分钟和秒
    //   const [hours, minutes, seconds] = data.split(':');
    //
    //   // 创建一个 Date 对象，日期部分不重要，时间部分设置为传入的值
    //   const date = new Date();
    //   date.setHours(parseInt(hours, 10));
    //   date.setMinutes(parseInt(minutes, 10));
    //   date.setSeconds(parseInt(seconds, 10));
    //
    //   // 使用 toLocaleTimeString 转换为 hh:mm A 格式
    //   return date.toLocaleTimeString('en-US', {
    //     hour: 'numeric',
    //     minute: '2-digit',
    //     hour12: true,
    //   });
    // }
  },
  watch: {
    couponsDialogFormVisible(val) {
      // 关闭弹窗
      if (!val) {
        this.clearData()
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
          this.valid = false
        })
      } else {
        if (this.row.id){
          this.couponsTitle = 'Edit a reward'
        }else{
          if (this.row.type){
            this.couponsTitle = 'Copy a reward'
          }else{
            this.couponsTitle =  'Create a reward'
          }
        }

        // 编辑优惠券
        if (Object.keys(this.row) && this.row.id) {
          Object.keys(this.couponsForm).forEach((key) => {
            if (this.row['spend_threshold'] == '0.00'){
              this.limitCheck = true
            }else {
              this.limitCheck = false
            }
            if (this.row[key]) {
              this.couponsForm[key] = this.row[key]
            }
          })
          // this.limitCheck = false
          this.copyData()
        }
        // 复制优惠券
        if (Object.keys(this.row) && !this.row.id) {
          this.copyData()
        }
      }
    }
  }
}
</script>
 <style lang="less" scoped>
.per_box{
  .el-input-group__append{
    background-color: #FFFFFF !important;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }
  .el-input__inner{
    border-right: none;
  }
}
.rate{
  /deep/ input{
    padding-left: 38px;
  }
}
.ts{
  /deep/ .el-input__suffix{
    display: flex;
    align-items: center;
  }
}
/deep/.ts.el-input--suffix{
  .el-input__suffix-inner{
    margin-right: 4px;
  }
  .el-input__validateIcon{
    margin-top: 0;
  }
}
.date_time{
  /deep/ .el-input--prefix .el-input__inner{
    padding-left: 12px;
  }
  /deep/ .el-input__prefix {
    position: absolute;
    top: 0;
    right: 12px !important;
    left: auto;
  }
  /deep/ .el-icon-circle-check{
    &::before{
      display: none;
    }
  }
  /deep/ .el-input__suffix{
    right: 34px;
  }
}
/deep/ .el-checkbox-group{
  width: 100%;
  display: inline-block;
}
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #000000;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
  background-color: #000000;
  border-color: #000000;
  &:hover{
    border-color: #000000;
  }
}
/deep/ .el-checkbox__inner:hover, .el-checkbox__inner:focus{
  border-color: #000000 !important;
}
/deep/ .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #000000 !important;
}
.valid{
  /deep/ .el-checkbox__inner{
    border-color: #E95646;
  }
}
</style>
